import { InfoOutlined } from '@mui/icons-material';
import { Grid, Tooltip, Typography } from '@mui/material';
import { NumberInputWidget } from 'src/components/widget';

import { AssemblySectionRotationAreaProps } from './AssemblySectionRotationArea.interface';
import {
  PlayArrowIconStyled,
  StopIconStyled,
  StyledLinkTypography,
} from './AssemblySectionRotationArea.styled';

export const AssemblySectionRotationArea = (
  props: AssemblySectionRotationAreaProps,
) => {
  const {
    inputLabel,
    inputTooltip,
    inputValue,
    onInputChange,
    onPreviewClick,
    preview,
    previewButtonLabel,
    title,
    disabled,
    options,
    error,
    helperText,
  } = props;

  return (
    <Grid container gap={2} direction="column">
      {title && <Typography variant="subtitle1">{title}</Typography>}

      {!options?.hidePreviewBtn && (
        <Grid
          container
          gap={1.5}
          alignItems="center"
          wrap="nowrap"
          onClick={onPreviewClick}
          sx={{
            cursor: 'pointer',
          }}>
          <Grid item xs={1} display="flex">
            {preview ? <StopIconStyled /> : <PlayArrowIconStyled />}
          </Grid>
          <Grid item xs={11}>
            <StyledLinkTypography fontWeight="400" active={preview}>
              {previewButtonLabel}
            </StyledLinkTypography>
          </Grid>
        </Grid>
      )}

      {!options?.hideInput && onInputChange && (
        <NumberInputWidget
          label={
            <Grid container justifyContent="space-between" gap={1}>
              <Typography
                fontWeight="400"
                variant="subtitle1"
                color="textSecondary">
                {inputLabel}
              </Typography>
              <Tooltip title={inputTooltip} arrow placement="right">
                <InfoOutlined color="secondary" />
              </Tooltip>
            </Grid>
          }
          value={inputValue}
          options={{
            size: 'small',
            min: 0,
          }}
          onChange={(value) => onInputChange(value as number)}
          disabled={disabled}
          hasError={error}
          error={helperText}
        />
      )}
    </Grid>
  );
};
